export const Grid = () => {
    return (
        <>
            <div className="grid__section">
                <ul className="gridList">
                    <li className="gL__item selected bTs01">
                        <div className="gLi__body">
                            <div className="gLi__title">NFT Valuation and Recommendation</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g01"></i></div>
                        </div>
                    </li>
                    <li className="gL__item bTs02">
                        <div className="gLi__body">
                            <div className="gLi__title">Blockchain Analytics</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g02"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs03">
                        <div className="gLi__body">
                            <div className="gLi__title">Smart Contract Auditor</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g03"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs04">
                        <div className="gLi__body">
                            <div className="gLi__title">Algorithmic Trading</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g04"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs05">
                        <div className="gLi__body">
                            <div className="gLi__title">Creative Content Generator</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g05"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs06">
                        <div className="gLi__body">
                            <div className="gLi__title">Mining Optimization</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g06"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs07">
                        <div className="gLi__body">
                            <div className="gLi__title">Trend Analyzer</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g07"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs08">
                        <div className="gLi__body">
                            <div className="gLi__title">Healthcare and Medical Research</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g08"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs09">
                        <div className="gLi__body">
                            <div className="gLi__title">Financial Market Analysis</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g09"></i></div>
                        </div>
                    </li>
                    <li className="gL__item noactive bTs10">
                        <div className="gLi__body">
                            <div className="gLi__title">Cybersecurity Defense</div>
                            <div className="gLi__bottom"><span className="gli__status"></span><i className="gli__icon g10"></i></div>
                        </div>
                    </li>
                </ul>
            </div>
            <div className="gridTabs__section">
                <ul className="gTs__list">
                    <li className="gTsl__item gTs01 visible">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>NFT Valuation and Recommendation</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Analyzes the non-fungible token (NFT) market, using image recognition and market data to
                                    evaluate and recommend NFT investments. GPUs accelerate the processing of complex
                                    algorithms that assess rarity, sentiment, and historical sales data.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs02">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Blockchain Analytics</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Specializes in analyzing blockchain transactions and wallet addresses for patterns,
                                    anomalies, or suspicious activities. It's crucial for ensuring security and compliance
                                    in the crypto space, with GPUs enabling the processing of complex blockchain datasets
                                    rapidly.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs03">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Smart Contract Auditor</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Automatically reviews and audits smart contract code for vulnerabilities or
                                    inefficiencies. By simulating millions of transaction scenarios quickly through GPU
                                    acceleration, it helps secure and optimize contracts on blockchain networks.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs04">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Algorithmic Trading</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Utilizes machine learning to analyze historical and real-time market data, executing
                                    trades based on predictive models. Enhanced by GPUs, it can process vast arrays of
                                    financial indicators and news sources in milliseconds to capitalize on market movements.
                                </p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs05">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Creative Content Generator</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Utilizing GANs (Generative Adversarial Networks), this bot generates original content,
                                    including images, videos, and music. The heavy lifting of rendering and processing is
                                    handled by GPUs to produce high-quality outputs.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs06">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Mining Optimization</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Optimizes the configuration and operation of GPU-based cryptocurrency mining rigs. It
                                    continuously analyzes the performance and profitability of different cryptocurrencies,
                                    adjusting mining strategies in real-time for optimal returns.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs07">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Trend Analyzer</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Processes vast amounts of data from patents, publications, and market reports to identify
                                    emerging trends and technologies in the tech industry. This bot helps companies stay
                                    ahead by leveraging GPUs to conduct deep analysis and prediction models.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs08">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Healthcare and Medical Research</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>A bot designed to process medical images (such as MRIs and X-rays) using deep learning to
                                    assist in diagnosing diseases or to simulate drug interactions at the molecular level
                                    for research purposes.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs09">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Financial Market Analysis</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>Using complex algorithms to analyze market data in real-time, this bot provides insights
                                    and predictions on financial markets. It can process vast datasets quickly to identify
                                    trends, perform risk analysis, and execute high-frequency trading.</p>
                            </div>
                        </div>
                    </li>
                    <li className="gTsl__item gTs10">
                        <div className="gTsi__body">
                            <div className="gTsib__left">
                                <div className="gTs__icon"></div>
                                <div className="gTsi__title">
                                    <h3>Cybersecurity Defense</h3>
                                </div>
                            </div>
                            <div className="gTsib__right">
                                <p>By monitoring network traffic and analyzing patterns using machine learning, this bot
                                    identifies and responds to cybersecurity threats in real-time. GPUs enable the
                                    processing of large datasets to detect anomalies and potential attacks efficiently.</p>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </>
    )
}

export default Grid;